module.exports = __webpack_public_path__ + "img/social-profile-bubble.cb587e46.svg";